module.exports = __webpack_public_path__ + "static/img/family00.522f508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/family00.jpg
// module id = vhAi
// module chunks = 0